import React from "react";

const servicesData = [
    {
        icon: "fas fa-code",
        title: "Website Building",
        subtitle: "Easy & Fast",
        description:
            "Globally fashion client-focused synergy for accurate synergy. Quickly network cost-effective ideas rather than standardized leadership.",
    },
    {
        icon: "fab fa-wordpress",
        title: "Managed WordPress",
        subtitle: "Suitable For All Users",
        description:
            "Interactively syndicate alternative opportunities via ubiquitous systems. Network cost-effective ideas rather than standardized leadership.",
    },
    {
        icon: "fas fa-headset",
        title: "Dedicated Support",
        subtitle: "Commitment To",
        description:
            "Quickly network cost-effective ideas rather than standardized leadership. Interactively syndicate alternative opportunities via ubiquitous systems.",
    },
    {
        icon: "fas fa-paper-plane",
        title: "Website Transfer",
        subtitle: "Easy & Smooth",
        description:
            "Globally fashion client-focused synergy for accurate synergy. Quickly network cost-effective ideas rather than standardized leadership.",
    },
];

const Services = () => {
    return (
        <section className="ptb-100 service-section-wrap">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-10 col-lg-6">
                        <div className="section-heading text-center mb-5">
                            <h2>Our Tools And Services For Optimized Website Building</h2>
                            <p>
                                Uniquely repurpose strategic core competencies with progressive content. Assertively transition ethical imperatives and collaborative solutions.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row g-4">
                    {servicesData.map((service, index) => (
                        <div key={index} className="col-md-6 col-lg-6">
                            <div className="single-service p-5 rounded border gray-light-bg">
                                <div className="service-header d-flex align-items-center justify-content-between">
                                    <h4>
                                        <span className="h5 text-uppercase">{service.subtitle}</span>
                                        <br />
                                        {service.title}
                                    </h4>
                                    <span className={`${service.icon} fa-3x color-primary`}></span>
                                </div>
                                <p>{service.description}</p>
                                <a href="#" className="btn btn-outline-primary mt-3">
                                    View more details
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
